/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetDefaultFacilityPhysician200ResponseData } from './SetDefaultFacilityPhysician200ResponseData';
import {
    SetDefaultFacilityPhysician200ResponseDataFromJSON,
    SetDefaultFacilityPhysician200ResponseDataFromJSONTyped,
    SetDefaultFacilityPhysician200ResponseDataToJSON,
    SetDefaultFacilityPhysician200ResponseDataToJSONTyped,
} from './SetDefaultFacilityPhysician200ResponseData';

/**
 * 
 * @export
 * @interface SetDefaultFacilityPhysician200Response
 */
export interface SetDefaultFacilityPhysician200Response {
    /**
     * 
     */
    data?: SetDefaultFacilityPhysician200ResponseData;
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysician200Response interface.
 */
export function instanceOfSetDefaultFacilityPhysician200Response(value: object): value is SetDefaultFacilityPhysician200Response {
    return true;
}

export function SetDefaultFacilityPhysician200ResponseFromJSON(json: any): SetDefaultFacilityPhysician200Response {
    return SetDefaultFacilityPhysician200ResponseFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysician200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysician200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SetDefaultFacilityPhysician200ResponseDataFromJSON(json['data']),
    };
}

export function SetDefaultFacilityPhysician200ResponseToJSON(json: any): SetDefaultFacilityPhysician200Response {
    return SetDefaultFacilityPhysician200ResponseToJSONTyped(json, false);
}

export function SetDefaultFacilityPhysician200ResponseToJSONTyped(value?: SetDefaultFacilityPhysician200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SetDefaultFacilityPhysician200ResponseDataToJSON(value['data']),
    };
}

